import queryString from 'query-string';

interface MidwayAuthParams {
    scope: string;
    response_type: string;
    client_id: string;
    redirect_uri: string;
    nonce: string;
}

const buildMidwayAuthRequest = (isRedirectRequest = false) => {
    const paramsObject: MidwayAuthParams = {
        scope: 'openid',
        response_type: 'id_token',
        client_id: window.location.origin,
        redirect_uri: document.location.href,
        nonce: Math.random().toString(36).substring(2,15) + Math.random().toString(36).substring(2,15)
    };

    const params = queryString.stringify(paramsObject);
    return `https://midway-auth.amazon.com/SSO${isRedirectRequest ? '/redirect' : ''}?${params}`;
};

const fetchIdentityToken = () => {
    return fetch(buildMidwayAuthRequest(), { credentials: 'include' })
        .then((response) => response.ok ? response.text() : Promise.reject(Error(response.statusText)));
};

export const getIdentityToken = async () => {
    if (process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost') {
        return 'local-dev-token';
    }
    try {
        return await fetchIdentityToken();
    } catch (e) {
        window.location.assign(buildMidwayAuthRequest(true));
        return null;
    }
};

export const getUserName = async (): Promise<string | undefined> => {
    const token = await getIdentityToken();
    if (token) {
        try {
            const { jwtDecode } = await import('jwt-decode');
            return jwtDecode(token).sub;
        } catch (error) {
            console.error('Error decoding token:', error);
            return undefined;
        }
    }
    return undefined;
};

export const isAuthenticated = async (): Promise<boolean> => {
    try {
        return !!(await getIdentityToken());
    } catch (error) {
        return false;
    }
};

export const logout = () => window.location.reload();
